var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22012 5.34206C3.3611 5.20112 3.55229 5.12195 3.75163 5.12195C3.95098 5.12195 4.14217 5.20112 4.28315 5.34206L8.00454 9.06345L11.7259 5.34206C11.8677 5.20512 12.0576 5.12934 12.2547 5.13105C12.4519 5.13277 12.6404 5.21183 12.7798 5.35122C12.9192 5.49061 12.9983 5.67917 13 5.87629C13.0017 6.07341 12.9259 6.26331 12.789 6.4051L8.53606 10.658C8.39508 10.7989 8.20389 10.8781 8.00454 10.8781C7.80519 10.8781 7.614 10.7989 7.47302 10.658L3.22012 6.4051C3.07918 6.26412 3 6.07293 3 5.87358C3 5.67423 3.07918 5.48305 3.22012 5.34206Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown1);
export default __webpack_public_path__ + "static/media/down1.06238fbcb0b4bcbce3d1e5d0efb24285.svg";
export { ForwardRef as ReactComponent };